'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ShowHideButton = require('./buttons/ShowHideButton');

var _ShowHideButton2 = _interopRequireDefault(_ShowHideButton);

var _MoveSectionButton = require('./buttons/MoveSectionButton');

var _MoveSectionButton2 = _interopRequireDefault(_MoveSectionButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TocItem = function (_Component) {
  _inherits(TocItem, _Component);

  function TocItem(props) {
    _classCallCheck(this, TocItem);

    //bind this to the following
    var _this = _possibleConstructorReturn(this, (TocItem.__proto__ || Object.getPrototypeOf(TocItem)).call(this, props));

    _this.onClick = _this.onClick.bind(_this);
    return _this;
  }

  _createClass(TocItem, [{
    key: 'onClick',
    value: function onClick(e) {
      //We don't want to scroll when one of the toc buttons is pressed
      if (e.target.type !== "button") {
        this.props.scrollToSectionCB(this.props.id);
      } else {
        return false;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      //TODO limit string length on title, put full title in hover
      return _react2.default.createElement(
        'div',
        { className: 'TocItem', onClick: this.onClick },
        _react2.default.createElement(
          'div',
          { className: !this.props.isVisible ? "halfOpacity" : "" },
          _react2.default.createElement(
            'div',
            { className: 'alignleft' },
            _react2.default.createElement(_ShowHideButton2.default, { isVisible: this.props.isVisible, toggleVisibleCB: this.props.toggleVisibleCB, id: this.props.id }),
            _react2.default.createElement(
              'span',
              { className: 'indent-15' },
              this.props.title
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'alignright no-wrap indent-15' },
            _react2.default.createElement(_MoveSectionButton2.default, { id: this.props.id,
              direction: -1,
              disabled: !this.props.moveUpEnabled,
              moveSectionCB: this.props.moveSectionCB,
              altColor: true,
              size: 1 }),
            _react2.default.createElement(
              'span',
              { className: 'indent-5' },
              _react2.default.createElement(_MoveSectionButton2.default, {
                id: this.props.id, direction: 1,
                disabled: !this.props.moveDownEnabled,
                moveSectionCB: this.props.moveSectionCB,
                altColor: true,
                size: 1 })
            )
          )
        )
      );
    }
  }]);

  return TocItem;
}(_react.Component);

TocItem.propTypes = {
  title: _propTypes2.default.string,
  id: _propTypes2.default.number,
  isVisible: _propTypes2.default.bool,
  moveUpEnabled: _propTypes2.default.bool,
  moveDownEnabled: _propTypes2.default.bool,
  moveSectionCB: _propTypes2.default.func,
  toggleVisibleCB: _propTypes2.default.func,
  resetFilterCB: _propTypes2.default.func,
  scrollToSectionCB: _propTypes2.default.func
};

exports.default = TocItem;


//////////////////
// WEBPACK FOOTER
// ./node_modules/updox-care-record-viewer/lib/reactComponents/TocItem.js
// module id = 1237
// module chunks = 0